import { _ as _MapCache } from "./auth-service-tools1242.js";
import { _ as _setCacheAdd } from "./auth-service-tools1243.js";
import { _ as _setCacheHas } from "./auth-service-tools1244.js";
var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
}

SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
var _SetCache = SetCache;
export { _SetCache as _ };